export const isEvenNumber = (n: number) => !(n % 2);
